import { render } from "./OnDemandBookingRedirect.vue?vue&type=template&id=25f4f7d0&ts=true"
import script from "./OnDemandBookingRedirect.vue?vue&type=script&lang=ts"
export * from "./OnDemandBookingRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__